module.exports = __webpack_public_path__ + "img/A58A2212.2c77af5b.jpg";